module.exports = __webpack_public_path__ + "img/10.4a3ff4e9.png";